import { render } from "./FacebookPosts.vue?vue&type=template&id=44b2ebcc&scoped=true"
import script from "./FacebookPosts.vue?vue&type=script&lang=ts"
export * from "./FacebookPosts.vue?vue&type=script&lang=ts"

import "./FacebookPosts.vue?vue&type=style&index=0&id=44b2ebcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44b2ebcc"

export default script